import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingService } from './loading.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const SHOW_LOADER = request.headers.get('Loader');

    if (!SHOW_LOADER) {
      this.loadingService.sendingRequest();
    }

    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.receivingRequest();
      })
    );
  }
}
